export default class VeiculoViagemFinalizar {
    id!: number;
    fimViagemMilisegundos!: number;
}